module.exports = __webpack_public_path__ + "static/assets/86c8f63128ac36ec23acc15f757267a8.png";